export const msalConfig = {
  auth: {
    clientId: "dd34a5ad-9557-4c45-9cec-2c8a78cac33a",
    authority:
      "https://login.microsoftonline.com/9edcebe3-5449-4701-a2c1-c927e7289dd6",
    redirectUri: `${window.location.origin}`,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read", "Calendars.ReadWrite", "Mail.Read"],
};
